__turbopack_context__.v({
  "description": "ReserveNowFaq-module__9jrOWW__description",
  "modalWrapper": "ReserveNowFaq-module__9jrOWW__modalWrapper",
  "title": "ReserveNowFaq-module__9jrOWW__title",
});
